export default __webpack_public_path__ + "static/media/problem-statement-template.3c64b334.pdf";